/* Inquiry success: reuses the existing Google tag; no customer form fields. */
(() => {
  const root = document.querySelector('[data-ecm-inquiry-signal]');
  if (!root || root.dataset.ecmSignalReady) return;
  root.dataset.ecmSignalReady = 'true';
  // Shopify does not load this API on every storefront automatically.
  // Loading it reads the existing consent decision; never set consent here.
  let privacyAttempts = 0;
  const loadPrivacy = () => {
    const shop = window.Shopify;
    if (shop?.customerPrivacy) {
      root.dataset.ecmPrivacyApi = 'ready';
      return;
    }
    if (typeof shop?.loadFeatures !== 'function') {
      if (++privacyAttempts < 20) setTimeout(loadPrivacy, 250);
      else root.dataset.ecmPrivacyApi = 'unavailable';
      return;
    }
    root.dataset.ecmPrivacyApi = 'loading';
    try {
      shop.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        root.dataset.ecmPrivacyApi = !error && shop.customerPrivacy ? 'ready' : 'failed';
      });
    } catch (_) { root.dataset.ecmPrivacyApi = 'failed'; }
  };
  loadPrivacy();
  const form = root.querySelector('form');
  const key = 'ecm_inquiry_pending_v1';
  const path = location.pathname;
  const clear = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const allowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed() === true &&
        privacy?.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  };
  const success = !!root.querySelector('.b2b-enquiry__success');
  const error = !!root.querySelector('.b2b-enquiry__errors');
  if (error || (!success && form)) clear();
  if (!success && form) {
    form.addEventListener('submit', () => {
      clear();
      if (!allowed() || !form.checkValidity()) return;
      try {
        sessionStorage.setItem(key, JSON.stringify({path, time:Date.now()}));
      } catch (_) {}
    }, true);
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) clear();
  });
  if (!success || error) return;
  let attempts = 0;
  const emit = () => {
    attempts++;
    const shop = window.Shopify;
    // Wait briefly for Shopify's APIs, without changing consent or the form.
    if (!shop?.customerPrivacy || typeof shop?.analytics?.publish !== 'function') {
      if (attempts < 20) setTimeout(emit, 250);
      else clear();
      return;
    }
    if (!allowed()) { clear(); return; }
    if (typeof window.gtag !== 'function' && attempts < 20) {
      setTimeout(emit, 250);
      return;
    }
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(key)); }
    catch (_) { clear(); return; }
    clear(); // Consume before publishing: refresh must not send a second event.
    const age = Date.now() - pending?.time;
    if (!pending || pending.path !== path || !Number.isFinite(age) ||
        age < 0 || age > 20 * 60 * 1000) return;
    try {
      Promise.resolve(shop.analytics.publish('ecm_inquiry_success', {
        schema_version: 1,
        form_id: 'B2BContactForm'
      })).catch(() => {});
    } catch (_) {}
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'generate_lead', {
          send_to: 'G-K5YM3N5DFZ',
          form_id: 'B2BContactForm',
          page_location: location.origin + path,
          page_referrer: ''
        });
        // Queued is not proof of delivery: confirm in GA4 DebugView.
        root.dataset.ecmGa4 = 'queued';
      } catch (_) { root.dataset.ecmGa4 = 'failed'; }
    } else { root.dataset.ecmGa4 = 'unavailable'; }
  };
  emit();
})();